import { Link } from 'react-router-dom'
import SEO from '../../seo/SEO'
import { generateServiceSchema } from '../../seo/structuredData'
import './Servicios.css'

const Servicios = () => {
  const servicios = [
    {
      icon: "📊",
      title: "Contabilidad General",
      description: "Llevamos la contabilidad completa de tu empresa con precisión y profesionalismo.",
      features: [
        "Registro de operaciones contables",
        "Balances y estados financieros",
        "Conciliaciones bancarias",
        "Análisis de costos y gastos"
      ],
    },
    {
      icon: "📋",
      title: "Asesoramiento Impositivo",
      description: "Te ayudamos a cumplir con todas las obligaciones fiscales de manera eficiente.",
      features: [
        "Liquidación de impuestos",
        "Regímenes especiales",
        "Planificación fiscal",
        "Auditorías impositivas"
      ],
    },
    {
      icon: "💰",
      title: "Liquidación de Sueldos",
      description: "Cálculo preciso de salarios, aportes y contribuciones para tus empleados.",
      features: [
        "Liquidación mensual de sueldos",
        "Cálculo de aportes y contribuciones",
        "Libros de sueldos y jornales",
        "Certificados de ingresos"
      ],
    },
    {
      icon: "🦺",
      title: "Higiene y Seguridad Laboral",
      description: "Gestión integral de riesgos laborales y programas de prevención para tu empresa.",
      features: [
        "Evaluación y gestión de riesgos laborales",
        "Diseño e implementación de programas de prevención",
        "Auditorías e inspecciones de seguridad",
        "Elaboración de planes de emergencia y evacuación",
        "Formación y capacitación de talleres para empleados",
        "Servicio técnico y documentación",
        "Asesoramiento de equipos de protección personal (EPP)"
      ],
    },
    {
      icon: "🏢",
      title: "Consultoría Empresarial",
      description: "Asesoramiento estratégico para optimizar la gestión de tu empresa.",
      features: [
        "Análisis financiero",
        "Proyecciones y presupuestos",
        "Reorganización empresarial",
        "Due diligence"
      ],
    },
    {
      icon: "📈",
      title: "Auditorías",
      description: "Revisión exhaustiva de estados contables y procesos internos.",
      features: [
        "Auditoría de estados contables",
        "Auditoría operativa",
        "Auditoría de cumplimiento",
        "Informes de gestión"
      ],
    },
    {
      icon: "💼",
      title: "Constitución de Empresas",
      description: "Te acompañamos en todo el proceso de constitución de tu empresa.",
      features: [
        "Asesoramiento en tipos societarios",
        "Tramitación ante organismos",
        "Registro de marca",
        "Apertura de cuenta bancaria"
      ],
    }
  ]

  const structuredData = servicios.map(servicio => 
    generateServiceSchema(servicio.title, servicio.description)
  )

  return (
    <>
      <SEO 
        title="Servicios Contables"
        description="Servicios contables profesionales del Estudio Contable Vanesa Mondejar: contabilidad general, asesoramiento impositivo, liquidación de sueldos, consultoría empresarial, auditorías y constitución de empresas. Más de 10 años de experiencia."
        canonical="https://vanesamondejar.com/servicios"
        structuredData={structuredData}
        keywords="servicios contables, estudio contable vanesa mondejar, contabilidad general, asesoramiento impositivo, liquidacion de sueldos, consultoria empresarial, auditoria, estudio contable"
      />
      
      <main className="servicios">
        <section className="servicios-hero">
          <div className="container">
            <div className="servicios-hero__content">
              <h1 className="servicios-hero__title">Nuestros Servicios</h1>
              <p className="servicios-hero__subtitle">
                Soluciones contables integrales adaptadas a las necesidades específicas de tu empresa
              </p>
            </div>
          </div>
        </section>

        <section className="servicios-grid">
          <div className="container">
            <div className="servicios-grid__content">
              {servicios.map((servicio, index) => (
                <div key={index} className="servicios-grid__card">
                  <div className="servicios-grid__card-header">
                    <div className="servicios-grid__card-icon">
                      {servicio.icon}
                    </div>
                    <h2 className="servicios-grid__card-title">{servicio.title}</h2>
                    <p className="servicios-grid__card-description">{servicio.description}</p>
                  </div>
                  
                  <div className="servicios-grid__card-features">
                    <h3 className="servicios-grid__card-features-title">Incluye:</h3>
                    <ul className="servicios-grid__card-features-list">
                      {servicio.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="servicios-grid__card-features-item">
                          ✓ {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="servicios-grid__card-footer">
                    <Link 
                      to="/contacto" 
                      className="servicios-grid__card-cta"
                      state={{ servicio: servicio.title }}
                    >
                      Consultar
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="servicios-cta">
          <div className="container">
            <div className="servicios-cta__content">
              <h2 className="servicios-cta__title">¿No encontrás lo que buscás?</h2>
              <p className="servicios-cta__subtitle">
                Cada empresa es única. Contactanos para una consulta personalizada y diseñemos juntos la solución perfecta para tu negocio.
              </p>
              <div className="servicios-cta__actions">
                <Link to="/contacto" className="servicios-cta__button servicios-cta__button--primary">
                  Consulta Personalizada
                </Link>
                <a 
                  href="https://wa.me/5491166201346" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="servicios-cta__button servicios-cta__button--whatsapp"
                >
                  📱 WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export default Servicios
